export default "__VITE_ASSET__BHblpnZs__"